import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import { Loader } from 'components/simple';

const styles = {
  footer: {
    display: 'flex',
    justifyContent: 'center',
    padding: 2,
  },
};

export const InfiniteScrollFooter = ({ isLoading }) => {
  if (!isLoading) {
    return null;
  }

  return (
    <Box sx={styles.footer}>
      <Loader />
    </Box>
  );
};

InfiniteScrollFooter.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};
